import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-injuries',
  templateUrl: './team-injuries.component.html',
  styleUrls: ['./team-injuries.component.css']
})
export class TeamInjuriesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/team-injuries/team-injuries.component.ts